import type { Translate } from '../../../i18n/I18nProvider';

/**
 * Words for the codes the billing service writes on a ledger entry. Kept in
 * one place so the ledger, the usage page, the inbox chip and the broadcast
 * card all call a bot reply a bot reply.
 */

export function sourceKindLabel(t: Translate, kind: string | null | undefined): string {
  const code = kind ?? 'message';
  return t(`billing.source.${code}`, code);
}

export function categoryLabel(t: Translate, category: string | null | undefined): string {
  const code = category ?? 'other';
  return t(`billing.category.${code}`, code);
}

/** "message" / "messages", "1k tokens", "GB-day" …, for a count. */
export function unitLabel(t: Translate, unit: string | null | undefined, count: number): string {
  const code = unit ?? 'message';
  const one = Math.abs(count) === 1;
  return t(`billing.unit.${code}.${one ? 'one' : 'other'}`, code);
}

/** +27821234567 reads as +27 82 ••• 4567 where a whole team can see it. */
export function maskMsisdn(msisdn: string | null | undefined): string {
  if (!msisdn) return '';
  const digits = msisdn.replace(/\D/g, '');
  if (digits.length < 7) return msisdn;
  return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ••• ${digits.slice(-4)}`;
}
